import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsdoc/require-jsdoc */
import * as react from "react";
import { GetBlockKey } from "../helpers/blockKeyConverters.js";
export class DraggableBlockLineComponent extends react.Component {
    // eslint-disable-next-line babylonjs/available
    constructor(props) {
        super(props);
    }
    // eslint-disable-next-line babylonjs/available
    render() {
        return (_jsxs("div", { className: "draggableLine withButton", title: this.props.block.tooltip, draggable: true, onDragStart: (event) => {
                event.dataTransfer.setData("babylonjs-smartfilter-node", GetBlockKey(this.props.block.blockType, this.props.block.namespace));
            }, children: [this.props.block.blockType.replace("Block", ""), this.props.iconImage && this.props.iconTitle && this.props.onIconClick && (_jsx("div", { className: "icon", onClick: () => {
                        if (this.props.onIconClick) {
                            this.props.onIconClick();
                        }
                    }, title: this.props.iconTitle, children: _jsx("img", { className: "img", title: this.props.iconTitle, src: this.props.iconImage }) }))] }));
    }
}
//# sourceMappingURL=draggableBlockLineComponent.js.map